import React, { useState } from 'react';
import { Collapse, Spin, Typography, Empty } from 'antd';
import api from '../api';
import RecapMaterial from './RecapMaterial';

/**
 * What was written about an agent in a month on a campaign: their evaluations
 * (questions with a note or lost points, and comments) and their coaching
 * sessions created that month (request type, area, note and comments).
 * Reference for whoever writes the recap -- nothing here is copied into the
 * coaching session.
 *
 * Loaded the first time it is opened. The layout is RecapMaterial, shared with
 * Agent Summary's Generate Recap popup.
 */
export default function EvalCommentsPanel({ userId, campaignId, month }) {
  const [material, setMaterial] = useState(null);   // null = not loaded yet
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState(null);

  const load = () => {
    if (material || loading) return;
    setLoading(true);
    api.get('/api/coaching-recaps/eval-comments', { params: { user_id: userId, campaign_id: campaignId, month } })
      .then((r) => setMaterial({ evaluations: r.data?.evaluations || [], coaching: r.data?.coaching || [] }))
      .catch((err) => setError(err.response?.data?.error || 'Failed to load evaluation comments.'))
      .finally(() => setLoading(false));
  };

  const body = () => {
    if (loading) return <Spin size="small" />;
    if (error) return <Typography.Text type="danger">{error}</Typography.Text>;
    if (!material) return null;
    if (!material.evaluations.length && !material.coaching.length) {
      return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No evaluations or coaching sessions found." />;
    }
    return <RecapMaterial material={material} />;
  };

  return (
    <Collapse
      size="small"
      onChange={(keys) => { if (keys.length) load(); }}
      items={[{ key: 'c', label: 'Evaluation and coaching comments', children: body() }]}
    />
  );
}
